import React from "react";
import Box from "components/common/Box";
import Card from "components/common/Card";
import CardContent from "components/common/CardContent";
import Stack from "components/common/Stack";
import Text from "components/common/Text";
import Divider from "components/common/Divider";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { makeStyles } from "@mui/styles";
import { CircularProgress } from "@mui/material";

const DashboardPowerConsumed = (props) => {
  const classes = useStyles();

  return (
    <>
      <Card sx={{ minHeight: "380px" }}>
        {props.isLoadingpowerconsumeddata ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "200px",
              height: "20vh",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <CardContent>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Text className={classes.graphheading}>POWER CONSUMED</Text>

              <Box>
                <Stack direction="row" spacing={2}>
                  <Text className={classes.dateheading}>
                    {props?.power?.result?.since}-{props?.power?.result?.to}
                  </Text>
                </Stack>
              </Box>
            </Stack>

            <Divider
              sx={{ marginTop: "15px", marginBottom: "15px" }}
              variant="middle"
            />

            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
              sx={{ marginBottom: "1.6rem" }}
            >
              <Box>
                <Stack direction="row">
                  <Text className={classes.totalheading}>
                    Total Power Consumed :
                  </Text>
                  <Text className={classes.valueheading}>
                    {props?.power?.result?.total_power
                      ? props?.power?.result?.total_power
                      : "0"}
                    kw
                  </Text>
                </Stack>
              </Box>

              <Box>
                <Stack direction="row" spacing={2}>
                  <Text className={classes.totalheading}>
                    Avg Power Consumed :
                  </Text>
                  <Text
                    style={{ width: "75px", marginLeft: "3px" }}
                    className={classes.valueheading}
                  >
                    {props?.power?.result?.avg_power
                      ? props?.power?.result?.avg_power
                      : "0"}
                    kw
                  </Text>
                </Stack>
              </Box>
            </Stack>

            <HighchartsReact
              className={classes.HighchartsFirst}
              highcharts={Highcharts}
              options={props.options}
              sx={{ marginBottom: "1rem", backgroundColor: "red" }}
            />
          </CardContent>
        )}
      </Card>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  HighchartsFirst: {
    "& .highcharts-container": {
      width: "100% !important",
    },
    "& .highcharts-root": {
      width: "100% !important",
    },
  },

  graphheading: {
    fontSize: "15px",
    color: "#545454",
    letterSpacing: "0.09px",
    textTransform: "uppercase",
    font: "Nunito Sans",
    fontWeight: "bold",
  },

  dateheading: {
    fontSize: "14px",
    color: "#B4B4BE",
    font: "Nunito Sans",
  },

  totalheading: {
    fontSize: "12px",
    color: "#7E84A3",
    fontWeight: "600",
    font: "Nunito Sans",
  },

  valueheading: {
    fontSize: "12px",
    letterSpacing: "0.1px",
    color: "#545454",
    fontWeight: "600",
    font: "Nunito Sans",
    marginLeft: "3px",
  },
}));

export default DashboardPowerConsumed;
